import React from 'react'
import { Text, View } from 'oio-react'

const ToolTerminalHome = () => {
   return (
      <View
         display="flex"
         justifyContent="center"
         alignItems="center"
         width="100%"
         height="100vh"
         textAlign="center"
         padding="90px">
         <View>
            <Text size="12" weight="medium">
               Tool Terminal
            </Text>
            <Text size="5" color="#aaa">
               Coming Soon
            </Text>
         </View>
      </View>
   )
}

export default ToolTerminalHome
